import { render, staticRenderFns } from "./AdminContacts.vue?vue&type=template&id=31792ad2&scoped=true"
import script from "./AdminContacts.vue?vue&type=script&lang=js"
export * from "./AdminContacts.vue?vue&type=script&lang=js"
import style0 from "./AdminContacts.vue?vue&type=style&index=0&id=31792ad2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31792ad2",
  null
  
)

export default component.exports